export default {"src":"/_next/static/media/info-circle-mid-gradient1.b486546b.svg","height":40,"width":41};